var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMarketplaceStar = function SvgMarketplaceStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0008 15.7948L6.09432 17.8481C5.25257 18.2908 4.26923 17.5761 4.42965 16.6386L5.17557 12.2883L2.01498 9.20689C1.33357 8.54331 1.70965 7.38698 2.65032 7.24948L7.01832 6.61506L8.97157 2.65648C9.3924 1.80331 10.6082 1.80331 11.029 2.65648L12.9822 6.61506L17.3503 7.24948C18.291 7.38598 18.6671 8.54223 17.9858 9.20689L14.8252 12.2883L15.5711 16.6386C15.7315 17.5762 14.7481 18.2908 13.9064 17.8481L10.0008 15.7948Z",
    fill: "url(#paint0_linear_15625_3627)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_15625_3627",
    x1: 10.0003,
    y1: 2.01623,
    x2: 10.0003,
    y2: 17.9829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE61C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA929"
  })))));
};
export default SvgMarketplaceStar;